

































import { defineComponent, PropType } from "@nuxtjs/composition-api";
import CategoryProductCard from "~/modules/catalog/category/components/views/CategoryProductCard.vue";
import type { Product } from "~/modules/catalog/product/types";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";
import { Navigation, Pagination, Scrollbar } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
SwiperCore.use([Navigation, Pagination, Scrollbar]);

export default defineComponent({
  components: {
    SkeletonLoader,
    CategoryProductCard,
    Swiper,
    SwiperSlide,
  },
  props: {
    productsApi: {
      type: Array as PropType<Product[]>,
      required: true,
    },
    classItem: {
      type: String,
      default: "",
    },
    classItemParent: {
      type: String,
      default: "block-product__items",
    },

    optionItem: {
      type: Object,
      default: {},
    },
    sizeGuide: {
      type: String,
      default: null,
    },
    loading: Boolean,
    item: {
      type: Object,
      default: () => {},
    },
  },
});
